import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconChevronDown = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.293 14.7071C11.6835 15.0976 12.3167 15.0976 12.7072 14.7071L16.7072 10.7071L15.293 9.29289L12.0001 12.5858L8.70718 9.29289L7.29297 10.7071L11.293 14.7071Z"
        />
      </svg>
    );
  }
);
